import React, { createContext, useEffect, useRef, useState } from 'react'
import { updateMapOption } from 'containers/Maps/Map/mapSlice'
import { checkIsSmallScreen } from 'utils/screen'
import { useDispatch } from 'react-redux'
import { isIos } from 'utils/mobile'

/**
 * `true` when the mobile layout is rendered (screen width < 996px).
 * Reactive - updates on resize. Use it for every layout-dependent behaviour.
 */
export const ViewContext = createContext<boolean>(false)

export function ViewProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [isSmallScreen, setSmallScreen] = useState(checkIsSmallScreen())
  const currentIsSmallScreen = useRef(isSmallScreen)
  currentIsSmallScreen.current = isSmallScreen

  const dispatch = useDispatch()

  useEffect(() => {
    const isIOS = isIos()
    const onResize = () => {
      const nowIsSmallScreen = checkIsSmallScreen()
      if (nowIsSmallScreen !== currentIsSmallScreen.current) {
        setSmallScreen(s => !s)
        dispatch(updateMapOption({ zoom: nowIsSmallScreen ? 5 : 6 }))
      }
    }

    const orientationchange = () => {
      window.scrollTo(0, 0)
    }

    onResize()
    window.addEventListener('resize', onResize)
    if (isIOS) {
      window.addEventListener('orientationchange', orientationchange)
    }
    return () => {
      window.removeEventListener('resize', onResize)
      if (isIOS) {
        window.removeEventListener('orientationchange', orientationchange)
      }
    }
  }, [dispatch])

  return (
    <ViewContext.Provider value={isSmallScreen}>
      {children}
    </ViewContext.Provider>
  )
}
